import template from './insufficient-funds.jade';

export default [function() {
	return {
		template,
		scope: {
			isSubagent: '=',
		},
		controller: [
			'placingTermsApi', 'deviceService',
			function (placingTermsApi, deviceService) {
				this.isMobile = deviceService.isMobile;
				this.shouldPayByCard = placingTermsApi.shouldPayByCard;
				this.showRefillAccountPopup = placingTermsApi.showRefillAccountPopup;
			}
		],
		controllerAs: 'insufficientFundsCtrl',
	}
}];
